export const replaceFillColor = (svgString?: string): string => {
  if (!svgString) {
    return '';
  }
  return svgString.replace(/fill="#[0-9A-Fa-f]{6}"/g, 'fill="currentColor"');
};
